import { FC } from "react";
import { Box, ResponsiveValue } from "@chakra-ui/react";
import { ValueAnimationTransition, motion } from "framer-motion";

interface MotionProgressProps {
  value: number;
  transitionDuration: ResponsiveValue<string>;
  transitionStyle: ValueAnimationTransition;
}

export const ProgressBar: FC<MotionProgressProps> = ({
  value,
  transitionDuration,
  transitionStyle,
}) => {
  return (
    <Box
      borderRadius="2xl"
      bg="transparent"
      h="2rem"
      maxW="56.25rem"
      mb={16}
      overflow="hidden"
      position="relative"
      w="full"
      sx={{
        "&::after": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
          background: `linear-gradient(to right, #BECCFF, #FFE1A2, #FFC3BF)`,
          zIndex: 1,
        },
      }}
    >
      <motion.div
        style={{
          background: "var(--chakra-colors-th-cream2)",
          height: "100%",
          position: "absolute",
          right: 0,
          top: 0,
          width: "100%",
          zIndex: 2,
        }}
        animate={{
          width: `${100 - value}%`,
        }}
        transition={{
          duration: transitionDuration,
          ease: transitionStyle.ease,
        }}
      />
    </Box>
  );
};
